import { useEffect } from "react";
import { Outlet, useNavigate, Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Bot, PenLine, Library, LogOut } from "lucide-react";
import {
  SidebarProvider,
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { NavLink } from "@/components/NavLink";
import { Button } from "@/components/ui/button";

const navItems = [
  { title: "Dashboard", url: "/admin/dashboard", icon: LayoutDashboard },
  { title: "Agentes", url: "/admin/agents", icon: Bot },
  { title: "Criar Post", url: "/admin/create", icon: PenLine },
  { title: "Biblioteca", url: "/admin/library", icon: Library },
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (sessionStorage.getItem("iessa-admin") !== "true") {
      navigate("/admin", { replace: true });
    }
  }, [navigate]);

  const logout = () => {
    sessionStorage.removeItem("iessa-admin");
    navigate("/admin");
  };

  if (sessionStorage.getItem("iessa-admin") !== "true") return null;

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <Sidebar className="w-60 border-r border-sidebar-border">
          <div className="flex h-14 items-center gap-2 border-b border-sidebar-border px-4">
            <Bot className="h-6 w-6 text-sidebar-primary" />
            <span className="font-bold text-sidebar-foreground">IESSA Admin</span>
          </div>
          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupLabel>Menu</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {navItems.map((item) => (
                    <SidebarMenuItem key={item.url}>
                      <SidebarMenuButton asChild>
                        <NavLink
                          to={item.url}
                          className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-sidebar-foreground hover:bg-sidebar-accent"
                          activeClassName="bg-sidebar-accent text-sidebar-primary font-medium"
                        >
                          <item.icon className="h-4 w-4" />
                          <span>{item.title}</span>
                        </NavLink>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
          <div className="mt-auto border-t border-sidebar-border p-3">
            <Button variant="ghost" size="sm" className="w-full justify-start text-sidebar-foreground hover:bg-sidebar-accent" onClick={logout}>
              <LogOut className="mr-2 h-4 w-4" /> Sair
            </Button>
          </div>
        </Sidebar>

        <div className="flex flex-1 flex-col min-w-0">
          <header className="flex h-14 items-center border-b border-border bg-background px-3 sm:px-4">
            <SidebarTrigger className="mr-3 sm:mr-4" />
            <h2 className="truncate text-sm font-medium text-muted-foreground">
              {navItems.find((i) => location.pathname.startsWith(i.url))?.title || "Admin"}
            </h2>
          </header>
          <main className="flex-1 overflow-y-auto bg-muted/30 p-3 sm:p-4 md:p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default AdminLayout;
